<template>
    <div class="bizcomp-assets box">
        <!-- 用户信息区域 -->
        <UserInfo v-on:update-user-info="handleUserInfoUpdate" />
        <el-tabs v-model="activeType" class="tab">
            <el-tab-pane v-if="$util.checkModuleid(100001001)" name="assets" label="资产总览">
                <my-assets ref="assets"></my-assets>
            </el-tab-pane>
            <el-tab-pane
                v-if="$util.checkModuleid(100001002) && myPhaseDisplay"
                name="phase"
                label="盈亏查询"
            >
                <my-phase ref="phase"></my-phase>
            </el-tab-pane>
            <!-- <el-tab-pane name="combination" label="组合投资">
                <combo-assets ref="comboAssets"></combo-assets>
            </el-tab-pane> -->
            <el-tab-pane
                v-if="
                    $util.checkModuleid(100001003) &&
                    $util.getConfig().hideFunc &&
                    !$util.isWebQueryMode()
                "
                name="collection"
                label="我的自选"
            >
                <my-collection ref="collection"></my-collection>
            </el-tab-pane>
        </el-tabs>
        <dalogChild
            width="520px"
            :dialog-visible.sync="showCertDialog"
            :copywriting-display="false"
            v-on:cancel="handleCertDialogClosed"
            v-on:confirm="handleCertDialogClosed"
        ></dalogChild>
        <el-dialog
            title="密码过期提示"
            :visible.sync="resetVisible"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            class="prop"
            width="420px"
        >
            <div class="info-box">
                <el-alert
                    :title="
                        '您的' +
                        (userOtherInfo.specialflag == 1
                            ? '交易'
                            : userOtherInfo.specialflag == 2
                            ? '登录'
                            : userOtherInfo.specialflag == 3
                            ? '登录密码和交易'
                            : '') +
                        '密码已过期，请立即修改！'
                    "
                    type="warning"
                    show-icon
                    :closable="false"
                />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click.once="forgetPwd">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import myAssets from "@/components/fund/myAssets";
import myCollection from "@/components/fund/myCollection";
import myPhase from "@/components/fund/myPhase";
import dalogChild from "@/components/acctInfo/dalogChild.vue";
import { getHomePopupQueue } from "@/util/homePopupQueue";
import UserInfo from "./userInfo.vue";

export default {
    name: "AssetTotal",
    components: {
        myAssets,
        myCollection,
        dalogChild,
        myPhase,
        UserInfo
    },
    mixins: [mixin],
    data() {
        return {
            activeType: "assets", // tab类型
            resetVisible: false,
            loginPwdType: "0",
            userOtherInfo: { specialflag: 0 },
            myPhaseDisplay: false, // 控制盈亏查询入口是否显示
            certDialogResolver: null, // 证件弹窗队列 resolve 回调
            showCertDialog: false // 证件上传引导弹窗
        };
    },
    watch: {
        activeType(val) {
            if (val == "assets") {
                this.$refs.assets.searchAssets();
            } else if (val == "combination") {
                this.$refs.comboAssets.getAssets();
            } else if (val == "collection") {
                this.$refs.collection.searchFund();
            }
        }
    },
    async created() {
        if (this.$route.query && this.$route.query.tab) {
            this.activeType = this.$route.query.tab;
            this.$router.replace({ path: this.$route.path, query: {} });
        }

        this.userOtherInfo = this.$cache.getUserOtherInfo();
        this.userInfo = this.$cache.getUser() || {};
        this.userInfo.headimage = this.$cache.getHeadImage();
        // if (!this.$util.getConfig().hideFunc) return;
        // // 1：需要强制修改交易密码，3：需要强制修改交易密码和登录密码
        // if (this.userOtherInfo.specialflag == "1" || this.userOtherInfo.specialflag == "3") {
        //     this.resetVisible = true;
        //     this.loginPwdType = 0;
        // }
        // // 2：需要强制修改登录密码;
        // if (this.userOtherInfo.specialflag == "2") {
        //     this.resetVisible = true;
        //     this.loginPwdType = 1;
        // }

        // 证件上传引导弹窗：注册到首页引导弹窗队列（确保在资产总览子组件条件渲染时也能正常弹出）
        const queue = getHomePopupQueue();
        queue.addStep({
            id: "certUploadGuide",
            order: 32,
            shouldShow: async () => {
                const acctInfo = this.$cache.getUser();
                // 登录后提示也受“未认证的个人投资者限制交易”参数控制，保持与交易前拦截口径一致。
                const needCertificateNotice = this.$cache.getCompanyInfoParam("25101611") === "1";
                return (
                    needCertificateNotice &&
                    (acctInfo.certificatecheck == "" || acctInfo.certificatecheck == "0") &&
                    !sessionStorage.getItem("isDialogShown")
                );
            },
            show: () =>
                new Promise((resolve) => {
                    this.certDialogResolver = resolve;
                    this.showCertDialog = true;
                })
        });

        this.resetVisible = false;
    },
    mounted() {
        // this.myPhaseDisplay =
        //     this.$cache.getParamValue("business_module") &&
        //     this.$cache.getParamValue("business_module").bizenable["027"];
    },
    methods: {
        // 处理用户信息更新（头像上传成功后触发）
        handleUserInfoUpdate(info) {
            this.userInfo = info;
        },
        // 证件上传弹窗关闭/确认时通知队列继续
        handleCertDialogClosed() {
            sessionStorage.setItem("isDialogShown", "true");
            if (this.certDialogResolver) {
                this.certDialogResolver();
                this.certDialogResolver = null;
            }
            this.showCertDialog = false;
        },
        /* 跳转到忘记密码页面 */
        forgetPwd() {
            if (this.loginPwdType == 0) {
                this.$router.push({ name: "changetpwd" });
            } else {
                this.$router.push({ name: "changelpwd" });
            }
        }
    }
};
</script>

<style lang="scss">
.box {
    background: var(--color-bg-page);
    border: 1px solid var(--color-divided);
    position: relative;
    margin-bottom: 20px;

    .tab {
        margin: 0 auto;
        width: 1150px;
        .el-tabs__nav-wrap:after {
            background: var(--color-divided);
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            padding: 0 0 20px;
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
}
</style>
